import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Tabs from '../../../../components/Tab/Tabs';
import UsersRolesDashboard from '../pages/UsersRolesDashboard/UsersRolesDashboard';
import UsersPermissionsDashboard from '../pages/UsersPermissionsDashboard/UsersPermissions';
import RolesPermissionsPage from '../pages/RolesPermissionsPage/RolesPermissionsPage';
import './RolesPermissionsDashboard.css';


const RolesPermissionsDashboard = () => {

    const [searchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") || "users-permissions";
    const [activeTab, setActiveTab] = useState(initialTab);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedUser, setSelectedUser] = useState(null);

    const renderTab = (activeTab) => {
        switch(activeTab) {
            // case "users-roles":
            //     return <UsersRolesDashboard />;
            case "users-permissions":
                return <UsersPermissionsDashboard />;
            case "roles-permissions":
                return <RolesPermissionsPage />;
            default:
                return <UsersRolesDashboard />;
        }
    }

    return (
        // <Container fluid className="user-management">
        //     {/* HEADER */}
        //     <div className="userContentHeader">
        //         <div className="userLogo">
        //             <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
        //         </div>
        //         <div className="headerRightPanel">
        //             <UserProfileDropdown />
        //         </div>
        //     </div>

        //     <Row className="user-management-header align-items-center">
        //         <Col className="headerLeft">
        //             <div
        //                 onClick={() => navigate('/user-management')}
        //                 style={{ cursor: 'pointer' }}
        //             >
        //                 <HomeSvg fillColor={'#002355'} />
        //             </div>
        //             <h5 className="title">Roles and Permissions</h5>
        //         </Col>

        //     </Row>

        //     {/* CONTENT */}
        //     <div className="dashboard-content">

        //     </div>

        // </Container>

        <div>   
            <Tabs 
                component={"RolesPermissionsManagement"}
                activeTab={activeTab}
                setActiveTab={(tab) => {
                    setActiveTab(tab);
                }}
            />

            <div
                className='tab-content-container'
            >
                {
                    renderTab(activeTab)
                }
            </div>

        </div>
    )
}

export default RolesPermissionsDashboard